// Datei: src/components/TreasureCollection.js (MIT STATISTIK)

import React, { useState, useEffect } from 'react';

const CHESTS = [
    { key: 'silver', name: 'Silber Schatztruhe', icon: '🥈' },
    { key: 'gold', name: 'Goldene Schatztruhe', icon: '🥇' },
    { key: 'diamond', name: 'Diamant Schatztruhe', icon: '💎' }
];

export function TreasureCollection() {
    const [opened, setOpened] = useState({});

    useEffect(() => {
        const stored = localStorage.getItem('treasure_collection');
        if (stored) {
            setOpened(JSON.parse(stored));
        }
    }, []);

    const getOpenedCount = (key) => { 
        return opened[key]?.count || 0;
    };

    const hasOpened = (key) => getOpenedCount(key) > 0;

    return (
        <div style={{ margin: '2rem 0' }}>
            <h3 style={{ textAlign: 'center' }}>🎁 Deine Schatztruhen Sammlung</h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1rem' }}>
                {CHESTS.map(chest => (
                    <div key={chest.key} style={{
                        background: hasOpened(chest.key) ? '#fff' : '#ddd',
                        border: '2px solid #ccc',
                        borderRadius: '8px',
                        padding: '1rem',
                        width: '140px',
                        textAlign: 'center',
                        opacity: hasOpened(chest.key) ? 1 : 0.5
                    }}>
                        <div style={{ fontSize: '2rem' }}>{chest.icon}</div>
                        <strong>{chest.name}</strong>
                        <div style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}>
                            {hasOpened(chest.key) ? `Geöffnet: ${getOpenedCount(chest.key)}x` : 'Noch nicht geöffnet'}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

// Diese Hilfsfunktion muss aufgerufen werden, wenn eine Truhe geöffnet wird!
export function markChestAsOpened(type) {
    const stored = localStorage.getItem('treasure_collection');
    const collection = stored ? JSON.parse(stored) : {};
    
    if (!collection[type]) {
        collection[type] = { count: 0 };
    }
    collection[type].count += 1;

    localStorage.setItem('treasure_collection', JSON.stringify(collection));
}
